<template>
  <div class="header-btn-lg pr-0">
    <div class="widget-content p-0">
      <div class="widget-content-wrapper">
        <div class="widget-content-left">
            <a @mouseover="showMenuUser = true" @mouseleave="showMenuUser = false"
               class="p-0 btn d-flex align-items-center">

              <div class="rounded-circle bg-primary" style="width: 42px; height: 42px; margin-top: 10px; font-size: 20px; color: #FFFFFF; line-height: 40px">
                {{ user.initials }}
              </div>

              <i class="fa fa-angle-down ml-2 opacity-8"></i>
              <t-app-user-submenu @closeSubmenu="closeSubmenu" :user="user" :class="{'display-none':!showMenuUser}"/>

            </a>
        </div>
        <div class="widget-content-left  ml-3 header-user-info">
          <div class="widget-heading">
            {{user.name}}
          </div>
          <div class="widget-subheading">
            {{user.profile}}
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import TAppUserSubmenu from "@/components/template/header/t-app-user-submenu";
import ui from "@/assets/scripts/ui";

export default {
  name: "t-app-user",
  components: {TAppUserSubmenu},
  data() {
    return {
      showMenuUser: false,

    }
  },
  methods: {
    closeSubmenu(){
      this.showMenuUser = false
    },
    exit() {
      ui.logout(this)
    },
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
}
</script>

